import { Tabs } from "@/components/Elements";
import { Posts } from "./post";
import { usePostViewQuery } from "@/services/modules/post";
import { useMemo } from "react";

enum PostTab {
  NearByPost = "Near by Posts",
  MyPost = "My Posts",
}

export const ViewPostScreen = () => {
  usePostViewQuery();

  const tabs = useMemo(
    () => [
      {
        id: PostTab.NearByPost,
        label: PostTab.NearByPost,
        Content: () => <Posts />,
      },
      {
        id: PostTab.MyPost,
        label: PostTab.MyPost,
        Content: () => <Posts getUserPost />,
      },
    ],
    []
  );

  return (
    <div className="flex-1">
      <Tabs tabs={tabs} />
    </div>
  );
};
